import React from 'react';

import Default, { Mobile } from '../../utils/mediaQueries';
import Schedule from './Schedule';
import Layout from '../../components/Layout';

async function action() {
  return {
    component: (
      <Layout>
        <Default>
          <Schedule />
        </Default>
        <Mobile>
          <Schedule mobile />
        </Mobile>
      </Layout>
    ),
  };
}

export default action;
